import { render, staticRenderFns } from "./WhEcharts.vue?vue&type=template&id=4a63ccb3&scoped=true"
import script from "./WhEcharts.vue?vue&type=script&lang=js"
export * from "./WhEcharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a63ccb3",
  null
  
)

export default component.exports